import type { UpdateUserPreferencesClients } from '@ms/yammer-graphql';
import { WebClientPreference } from '@ms/yammer-graphql';

type UserPreferencesNormalizer = (response: { readonly data: UpdateUserPreferencesClients }) => WebClientPreference;

export const normalizeUserPreferences: UserPreferencesNormalizer = ({ data: { updateUserPreferences } }) => {
  if (!updateUserPreferences) {
    return WebClientPreference.LEGACY;
  }

  return updateUserPreferences.userPreferences.webClientPreference;
};
